module.exports = __webpack_public_path__ + "img/oaks-nest-nook-1.725617eb.jpeg";